import {lighten} from 'polished';
import styled from 'styled-components';

import {breakpoint, colors} from 'theme';

export const HeaderControls = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap-reverse;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: 20px;
    }
`;

export const NavigationWrapper = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 300px;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: 20px;
    }
`;

export const ControlsWrapper = styled.div`
    width: 100%;
    @media (max-width: ${breakpoint.phone}) {
        flex-grow: 1;
    }
`;

export const GtinEditLink = styled.div`
    color: ${colors.brandPrimary};
    cursor: pointer;
`;

export const StatusWrapper = styled.div<{color: string}>`
    box-sizing: border-box;
    padding: 8px 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 12px;
    border-radius: 4px;
    color: ${(p) => p.color};
    background-color: ${(p) => lighten(0.38, p.color)};
`;

export const StatusWrapperText = styled(StatusWrapper)<{color: string}>`
    background-color: transparent;
`;
